// extracted by mini-css-extract-plugin
module.exports = {"B_2":"B_B_2__D15ct"};